<template>
  <!-- 续年度服务津贴 -->
  <div class="td">
    <Dropdown :visible="visible" trigger="custom" @mouseleave.native="closePreview" placement="left">
      <div class="btn" @mouseover="openPreview" @click="openConfigModal('serviceAllowanceModal')">
        <span v-if="topItem.sourceType == 2">{{ tableItem.isExistRenew ? '已配置' : '配置' }}</span>
        <span v-else>{{ tableItem.isExistRenew ? '查看' : '-' }}</span>
      </div>
      <template slot="list">
        <div class="list-item" v-if="list.length">
          <div class="tools-box">
            <span>续年度服务津贴</span>
          </div>
          <div class="table">
            <div class="tr">
              <div class="td th">方案</div>
              <div class="td th" v-for="head in headList" :key="head.id">{{ head.name }}</div>
              <div class="td th" v-for="(bean, i) in indexList" :key="bean.id" :class="{ 'big-td': payPeriodFull == 1 && i == indexList.length - 1 }">
                <span>{{ bean.name }}</span>
                <span v-if="payPeriodFull == 1 && i == indexList.length - 1">至交费期满</span>
              </div>
            </div>
            <div class="tr" v-for="row in list" :key="row.key">
              <div class="td">{{ row.name || '-' }}</div>
              <div class="td" v-for="head in headList" :key="head.key">{{ row[head.code] || '-' }}</div>
              <div class="td" v-for="(row2,i) in row.renewCommissionList" :key="row2.key" :class="{ 'big-td': payPeriodFull == 1 && i == indexList.length - 1 }">
                {{ row2.commission ? row2.commission + '%' : '-' }}
              </div>
            </div>
          </div>
        </div>
        <template v-if="list.length == 0">
          <!-- 商户的团险-->
          <div class="empty-item" v-if="topItem.productCategory != 3 && topItem.sourceType == 2">该配置暂未开放，请耐心等待</div>
          <!-- 非商户的团险 -->
          <div class="empty-item" v-else>未配置</div>
        </template>
      </template>
    </Dropdown>
  </div>
</template>
  
<script>
import serviceAllowance from './serviceAllowance.config.js';
import common from './common.config.js';
export default {
  mixins: [serviceAllowance, common],
  components: {},
  props: {
    tableItem: null,
    topItem: null
  },
  data() {
    return {
      visible: false,
      list: []
    };
  },
  computed: {},
  created() {},
  methods: {
  }
};
</script>
<style lang="scss" scoped>
@import './itemCommon.scss';
.table {
  max-width: 700px;
  overflow-x: auto;
  .tr {
    .big-td {
      flex: 160px;
      min-width: 160px;
      span{
        margin-left: 0 !important ;
      }
    }
  }
  
}
</style>  